export default __webpack_public_path__ + "static/media/HRFrontRunner.85efd6cb.png";